import EventTypes from "../../../shared/EventTypes";
import AbstractAction from "../AbstractAction";

export default class RemoveLayerAction extends AbstractAction {
    constructor(provider, layer) {
        super(provider);

        this.layer = layer;
    }

    finish() {
        this.redo();
        super.finish();
    }

    undo() {
        this.layers.add(this.layer);
        this.layer.row.show();
        this.layer.getElements().forEach(e => {
            e.layer = this.layer;
        });
        this.emit(EventTypes.ADD_LAYER, this.layer);
    }

    redo() {
        this.layers.remove(this.layer.id);
        this.layer.row.hide();
        this.layer.getElements().forEach(e => {
            e.layer = null;
        });
        this.emit(EventTypes.REMOVE_LAYER, this.layer);
    }
}
